const prefix = 'FORM';

export const UPDATE_FORM_STATE = `${prefix}/UPDATE_FORM_STATE`;
